import SinglePhoto from "../SinglePhoto"


const PagePhotos = ({ photos, page }) => {
    // console.log(photos, "<<<< ph[t")
    return (
        <>

            {photos.map((photo, idx) => {

                return (
                    <div key={idx}>

                        <SinglePhoto photo={photo} photos={photos} index={idx} />

                    </div>
                )
            })}

        </>
    )
}


export default PagePhotos;
